
<template lang="pug">
//-  模型关联
.childrenSub(v-loading="loading" element-loading-text="数据读取中...")
  .oper
    el-button( @click="addSubform" size="small" type="primary" :disabled="relationTypeBoolean" ) 添加关联
    .title 当前业务模型：
      span {{nodeData.groupName+"（"+nodeData.groupId+"）"}}
  .subTable
    vxe-table(border round resizable size="medium" show-overflow keep-source :span-method="rowspanMethod"
      ref="xTable" max-height="620" :data="subformList" :edit-config="{trigger: 'manual', mode: 'row', autoClear:false}")
      vxe-column(type="seq" width="55",align="center",title="序号")
      vxe-column(field="",align="center",title="从表业务模型名称" v-slot="{row}")
        span {{row.slaveTableBusinessName+"（"+row.slaveTableName+"）"}}
      vxe-column(field="",align="center",title="关系" :edit-render="{}")
        template(#default="{ row }")
          span {{row.relationType === 1 ? "一对一" : "一对多"}}
        template(#edit="{ row }")
          vxe-select(v-model="row.relationType" transfer size="medium")
            vxe-option(v-for="item in relationTypeList" :key="item.value" :value="item.value" :label="item.label")
      vxe-column(field="",align="center",title="关联字段(主表——子表)" :edit-render="{}")
        template(#default="{ row }")
          span.sheet {{row.masterFieldDisplayName+"（"+row.masterField+"）"}}
          span.correlation 关联
          span.sheet {{row.slaveFieldDisplayName+"（"+row.slaveField+"）"}}
        template(#edit="{ row }")
          .correEdit
            vxe-select(v-model="row.masterField" transfer size="medium")
              vxe-option(v-for="(item, index) in masterBusinessName.filter(e=>e.isCustomField===0)" :key="index" :value="item.columnName" :label="item.columnDisplayName")
            span.correlation 关联
            vxe-select(v-model="row.slaveField" transfer size="medium")
              vxe-option(v-for="item in slaveBusinessName.filter(e=>e.isCustomField===0)" :key="item.columnName" :value="item.columnName" :label="item.columnDisplayName")
      vxe-column(field="tableDesc",align="center",title="允许关联删除", :edit-render="{}")
        template(#default="{ row }")
          el-tooltip(content="主模型删除时数据，关联的数据也对应删除")
            el-checkbox(v-model="row.isAssociateDelete", :disabled="true", :true-label="1", :false-label="0")
              span 关联删除
        template(#edit="{ row }")
          el-tooltip(content="主模型删除时数据，关联的数据也对应删除")
            el-checkbox(v-model="row.isAssociateDelete", :true-label="1", :false-label="0")
              span 关联删除
      vxe-column(title="操作" align="center" width="160" v-slot="{row}")
        template(v-if="$refs.xTable.isActiveByRow(row)")
          vxe-button(type="primary" size="mini" @click="saveRowEvent(row)") 保 存
          vxe-button( size="mini" @click="cancelRowEvent(row)") 取 消
        template(v-else)
          vxe-button(type="primary" size="mini" @click="editRowEvent(row)") 编辑
          vxe-button( size="mini" @click="handleDel(row)") 删 除
  el-dialog(v-dialogDrag title="选择业务模型" :visible.sync="dataDialog" width="600px" :before-close="handleClose")
    .operList
      el-input(v-model='filterText' placeholder="输入关键字进行过滤",size="small" @change="changeData" )
      el-table(:data="tableData",border,height='300px',@selection-change="handleSelectionChange")
        el-table-column( type="selection",width="35" align="center" )
        el-table-column(prop="tableName" label="模型编号" sortable)
        el-table-column(prop="businessName" label="模型名称" sortable)
    template(#footer)
      el-button(@click="handleClose" size="small") 取 消
      el-button(type="primary" @click="onSubmit" size="small") 导 入
</template>
<script>
import "@/CommonDP/utils/vxe-table/index.js";
import metadataService from "@/CommonDP/service/metadata-service.js";
export default {
  data () {
    return {
      nodeData: {},
      dataDialog: false,
      filterText: "",
      initData: [],
      tableData: [],
      multipleSelection: [],
      loading: false,
      subformList: [],
      relationTypeList: [
        { label: "一对一", value: 1 },
        { label: "一对多", value: 2 }
      ],
      masterBusinessName: [], // 主表数据
      slaveBusinessName: [] // 子表数据
    };
  },
  computed: {
    relationTypeBoolean () {
      return false;
    }
  },
  watch: {},

  methods: {
    getcolumnList (data) {
      this.nodeData = data;
      console.log(this.nodeData);
      this.querySlaveTableList();
    },
    async querySlaveTableList () {
      this.loading = true;
      const res = await metadataService.querySlaveTableList(this.nodeData.groupId);
      this.subformList = res.data;
      this.loading = false;
    },
    // 根据业务模型查字段
    async getColumnList (groupId) {
      const { data } = await metadataService.columnList(groupId);
      const list = data || [];
      return list
        .sort((prev, next) => prev.columnDisplayName > next.columnDisplayName)
        .map((item) => {
          item.columnDisplayName = `${item.columnDisplayName}(${item.columnName})`;
          return item;
        });
    },
    // 编辑该行数据
    async editRowEvent (row) {
      const $table = this.$refs.xTable;
      // 获取主表字段列表
      if (this.masterBusinessName.length === 0) {
        this.masterBusinessName = (await this.getColumnList(this.nodeData.groupId)) || [];
      }
      this.slaveBusinessName = await this.getColumnList(row.slaveTableName);
      $table.setActiveRow(row);
    },
    cancelRowEvent (row) {
      const $table = this.$refs.xTable;
      $table.clearActived().then(() => {
        // 还原行数据
        $table.revertData(row);
      });
    },
    // 保存改行数据
    async saveRowEvent ({ id, masterField, relationType, slaveField, slaveTableName, masterTableName, isAssociateDelete }) {
      const masterSlaveList = [
        {
          id,
          masterField,
          relationType,
          slaveField,
          slaveTableName,
          masterTableName,
          isAssociateDelete
        }
      ];
      console.log(masterSlaveList);
      try {
        await metadataService.updateSlaveTableList({ masterSlaveList });
        this.$message.success("修改成功");
        this.querySlaveTableList();
      } catch (error) {
        console.log(error);
      }
    },
    // 添加关联子表
    addSubform () {
      this.queryDynMetaListByGroupID();
    },
    // 关联
    async queryDynMetaListByGroupID () {
      this.filterText = "";
      const res = await metadataService.queryDynMetaListByGroupID(this.nodeData.parentId);
      this.tableData = res.data
        .filter((e) => !this.subformList.some((i) => i.slaveTableName === e.tableName) && e.tableName !== this.nodeData.groupName)
        .map((item) => {
          item.tableNameLower = item.tableName?.toLocaleLowerCase();
          item.tableDescLower = item.tableDesc?.toLocaleLowerCase();
          item.keyFieldNames = item.tableNameLower + item.tableDescLower;
          return item;
        });
      this.initData = this.tableData;
      this.dataDialog = true;
    },
    changeData (val) {
      if (val) {
        val = val.toLocaleLowerCase();
        this.tableData = this.initData.filter((e) => e.keyFieldNames?.includes(val));
      } else {
        this.tableData = this.initData;
      }
    },
    // 加入子表
    async onSubmit () {
      if (this.multipleSelection.length === 0) {
        this.$warn("请选择需要导入的表");
        return;
      }
      const masterSlaveList = [];
      for (const row of this.multipleSelection) {
        const masterFieldList = await this.getColumnList(this.nodeData.groupId);
        const slaveFieldList = await this.getColumnList(row.tableName);
        const masterField = masterFieldList[0].columnName;
        const slaveField = slaveFieldList[0].columnName;
        masterSlaveList.push({
          id: "",
          masterField,
          masterTableName: this.nodeData.groupId,
          relationType: 2,
          isAssociateDelete: 1,
          slaveField,
          slaveTableName: row.tableName
        });
      }
      const res = await metadataService.updateSlaveTableList({ masterSlaveList });
      if (res.result === "0") {
        this.$message.success("添加成功");
        this.dataDialog = false;
        this.querySlaveTableList();
      }
    },
    async handleDel (row) {
      this.$confirm(`确认删除关联关系吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await metadataService.delSlaveTableList(row.id);
        this.$message.success("删除成功");
        this.querySlaveTableList();
      });
    },
    handleClose () {
      this.dataDialog = false;
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    rowspanMethod ({ row, rowIndex, $rowIndex, _rowIndex, column, columnIndex, $columnIndex, _columnIndex, data }) {
      // if (this.subformList.length === 0) {
      //   return;
      // }
      // if (_columnIndex === 2) {
      //   const _row = this.subformList[_rowIndex];
      //   const _col = _row > 0 ? 1 : 0;
      //   return {
      //     rowspan: _row,
      //     colspan: _col
      //   };
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.childrenSub {
  height: 100%;
  width: 100%;
  overflow-y: auto;

  .oper {
    height: 45px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .title {
      margin-left: 20px;
      // width: calc(100% - 160px);
      // display: flex;
      // justify-content: center;
      // align-content: center;
    }
  }
}

.correEdit {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.correlation {
  margin-left: 10px;
  min-width: 60px;
  margin-right: 10px;
}

.sheet {
  font-weight: 700;
  color: #4777e7;
}

.operList {
  .el-table {
    margin-top: 5px;
  }

  /deep/ .el-table__header-wrapper .el-checkbox {
    display: none;
  }
}

/deep/.vxe-table--render-default.vxe-editable .vxe-body--column,
.vxe-table--render-default.vxe-editable .vxe-body--column.col--actived {
  padding: 11px 0;
}
</style>
